import request from '@/utils/request'
let that = this

//列表
export function getAllInvention() {
  return request({
    url: 'invention/getAllInvention',
    method: 'get'
  })
}